import { Notification } from "src/components/common";
import { messages } from "src/constants/messages";

export default class Helpers {
  /**
   * Alert an success message
   * @param {string} message the success message
   * @returns {void}
   * @static
   * @memberof Helpers
   */
  static alertSuccessMessage = (message = "") => {
    Notification({
      type: "success",
      className: "notifi-success",
      message: messages.THONG_BAO,
      description: message
    });
  };

  /**
   * Alert an error message
   * @param {string} error the error message
   * @returns {void}
   * @static
   * @memberof Helpers
   */
  static alertError = (error = "") => {
    Notification({
      type: "error",
      className: "notifi-error",
      message: messages.THONG_BAO,
      description: error
    });
  };
/**
 *
 *
 * @static
 * @param {string} [message=""]
 * @memberof Helpers
 */
static alertWarning = (message = "") => {
    Notification({
      type: "warning",
      className: "notifi-warning",
      message: messages.THONG_BAO,
      description: message
    });
  };
}
